<template>
	<div
		class="configurator-canvas__holder">
		<canvas
			class="configurator-canvas"
			ref="canvas"
			:width="large ? 900 : 380"
			:height="large ? 900 : 380" />
		<div
			class="switch-sides"
			:class="{'switch-sides--large' : large, 'switch-sides--light': viewingPdf}">
			<span>
				U bekijkt: <strong>{{ viewingPdf ? "Geupload bestand": "Formaatsuggestie" }}</strong>
			</span>
			<span
				@click.stop="toggle"
				class="switch-sides__link">
				Klik hier om te wissellen
			</span>
		</div>

	</div>
</template>

<script>
export default {
	name: "SpecificationCanvas",
	data () {
		return {
			viewingPdf: true
		};
	},
	props: {
		large: {
			type: Boolean,
			default: false
		},
		data: {
			type: Object,
			default: null
		}
	},
	methods: {
		generateCanvas (toggle) {
			const canvas = this.$refs.canvas;
			const original = canvas.getContext("2d");
			const originalSecondary = canvas.getContext("2d");
			const uploaded = canvas.getContext("2d");
			const customSize = this.data.customSize;
			const inRange = this.data.inRange;

			const large = this.large;
			const strokeWidth = large ? 4 : 2;
			const x = canvas.width / 2;
			const y = canvas.height / 2;
			const padding = large ? 120 : 75;

			const canvasSize = [
				canvas.getAttribute("width"),
				canvas.getAttribute("height")
			];
			const originalRaw = [
				this.data.original.minWidth,
				this.data.original.maxWidth,
				this.data.original.minHeight,
				this.data.original.maxHeight
			];
			const originalSize = [
				(Math.round(((originalRaw[0] + originalRaw[1]) / 2) * 100) / 100),
				(Math.round(((originalRaw[2] + originalRaw[3]) / 2) * 100) / 100)
			];
			const sizeUploaded = [
				this.data.uploaded.width,
				this.data.uploaded.height
			];
			const sizeCustom = [
				this.data.custom.minWidth,
				this.data.custom.maxWidth,
				this.data.custom.minHeight,
				this.data.custom.maxHeight
			];
			const sizes = (customSize ? [
				(canvasSize[0] - padding) / originalSize[0],
				(canvasSize[1] - padding) / originalSize[1],
				(canvasSize[0] - padding) / sizeUploaded[0],
				(canvasSize[1] - padding) / sizeUploaded[1],
				(canvasSize[0] - padding) / customSize[0],
				(canvasSize[1] - padding) / sizeCustom[1],
				(canvasSize[0] - padding) / sizeCustom[2],
				(canvasSize[1] - padding) / sizeCustom[3]
			] : [
				(canvasSize[0] - padding) / originalSize[0],
				(canvasSize[1] - padding) / originalSize[1],
				(canvasSize[0] - padding) / sizeUploaded[0],
				(canvasSize[1] - padding) / sizeUploaded[1]
			]);

			const factor = Math.min.apply(null, sizes);

			function calcFactor (input) {
				return factor * input;
			}

			const _specification = [0, 0, calcFactor(originalSize[0]), calcFactor(originalSize[1])];
			const _uploaded = [0, 0, calcFactor(sizeUploaded[0]), calcFactor(sizeUploaded[1])];
			const _customSizeMin = [0, 0, calcFactor(sizeCustom[0]), calcFactor(sizeCustom[2])];
			const _customSizeMax = [0, 0, calcFactor(sizeCustom[1]), calcFactor(sizeCustom[3])];
			// draw original size

			function generateOriginal () {
				if (customSize) {
					original.save();

					original.translate(x - (_customSizeMax[2] / 2), y - (_customSizeMax[3] / 2));
					original.fillStyle = toggle ? "rgba(217, 239, 218, 0.6)" : "rgba(217, 239, 218, 0.8)";
					original.fillRect(_customSizeMax[0], _customSizeMax[1], _customSizeMax[2], _customSizeMax[3]);

					originalSecondary.strokeStyle = toggle ? "rgba(0,0,0,0.2)" : "#438c47"; // darkgreen
					originalSecondary.lineWidth = 2;
					originalSecondary.strokeRect(_customSizeMax[0] + 1, _customSizeMax[1] + 1, _customSizeMax[2] - 2, _customSizeMax[3] - 2);

					original.font = large ? "bold 23px Arial" : "14px Arial";
					original.fillStyle = toggle ? "#bbb" : "#555";
					original.fillText(sizeCustom[1] + "X" + sizeCustom[3] + "mm", 0, -8);

					original.restore();

					originalSecondary.save();

					originalSecondary.translate(x - (_customSizeMin[2] / 2), y - (_customSizeMin[3] / 2));
					originalSecondary.fillStyle = toggle ? "rgba(239, 217, 217, 0.4)" : "rgba(239, 217, 217, 0.8)";
					originalSecondary.fillRect(_customSizeMin[0], _customSizeMin[1], _customSizeMin[2], _customSizeMin[3]);

					originalSecondary.strokeStyle = toggle ? "rgba(0,0,0,0.2)" : "#8c4343"; // darkred
					originalSecondary.lineWidth = 2;
					originalSecondary.strokeRect(_customSizeMin[0] + 1, _customSizeMin[1] + 1, _customSizeMin[2] - 2, _customSizeMin[3] - 2);

					originalSecondary.font = large ? "bold 23px Arial" : "14px Arial";
					originalSecondary.fillStyle = toggle ? "#bbb" : "#555";
					originalSecondary.fillText(sizeCustom[0] + "X" + sizeCustom[2] + "mm", 0, -8);

					originalSecondary.restore();
				} else {
					original.save();

					original.translate(x - (_specification[2] / 2), y - (_specification[3] / 2));
					original.fillStyle = "rgba(255,255,255, 0.85)";
					original.strokeStyle = toggle ? "rgba(0,0,0,0.2)" : "#fddd05";
					original.lineCap = "square";
					original.fillRect(_specification[0], _specification[1], _specification[2], _specification[3]);
					original.beginPath();

					original.lineWidth = strokeWidth;

					original.moveTo(_specification[0], _specification[1]);
					original.lineTo(_specification[2], _specification[0]);
					original.lineTo(_specification[2], _specification[3]);
					original.lineTo(_specification[1], _specification[3]);
					original.lineTo(_specification[1], _specification[0]);
					original.stroke();

					original.font = large ? "bold 23px Arial" : "14px Arial";
					original.fillStyle = toggle ? "#bbb" : "#555";
					original.fillText(originalSize[0] + "X" + originalSize[1] + "mm", 0, -8);

					original.restore();
				}
			}

			// draw uploaded size
			function generateUploaded () {
				uploaded.save();

				uploaded.translate(x - (_uploaded[2] / 2), y - (_uploaded[3] / 2));
				uploaded.fillStyle = toggle ? "rgba(49, 145, 193, 0.8)" : "rgba(49, 145, 193, 0.5)";
				uploaded.fillRect(_uploaded[0], _uploaded[1], _uploaded[2], _uploaded[3]);

				// top
				uploaded.beginPath();
				uploaded.moveTo(_uploaded[0], _uploaded[1]);
				uploaded.lineTo(_uploaded[2], _uploaded[0]);
				uploaded.lineWidth = strokeWidth;
				uploaded.lineCap = "square";
				uploaded.strokeStyle = inRange.width ? (toggle ? "#32cd32" : "#90ee90") : (toggle ? "red" : "#F08080");
				uploaded.stroke();

				// bottom
				uploaded.beginPath();
				uploaded.moveTo(_uploaded[0], _uploaded[3]);
				uploaded.lineTo(_uploaded[2], _uploaded[3]);
				uploaded.lineWidth = strokeWidth;
				uploaded.lineCap = "square";
				uploaded.strokeStyle = inRange.width ? (toggle ? "#32cd32" : "#90ee90") : (toggle ? "red" : "#F08080");
				uploaded.stroke();

				// right
				uploaded.beginPath();
				uploaded.moveTo(_uploaded[2], _uploaded[0]);
				uploaded.lineTo(_uploaded[2], _uploaded[3]);
				uploaded.lineWidth = strokeWidth;
				uploaded.lineCap = "square";
				uploaded.strokeStyle = inRange.height ? (toggle ? "#32cd32" : "#90ee90") : (toggle ? "red" : "#F08080");
				uploaded.stroke();

				// left
				uploaded.beginPath();
				uploaded.moveTo(_uploaded[0], _uploaded[0]);
				uploaded.lineTo(_uploaded[0], _uploaded[3]);
				uploaded.lineWidth = strokeWidth;
				uploaded.lineCap = "square";
				uploaded.strokeStyle = inRange.height ? (toggle ? "#32cd32" : "#90ee90") : (toggle ? "red" : "#F08080");
				uploaded.stroke();

				uploaded.font = large ? "bold 23px Arial" : "14px Arial";
				uploaded.fillStyle = toggle ? "#555" : "#bbb";
				uploaded.textAlign = "right";
				uploaded.fillText(sizeUploaded[0] + "X" + sizeUploaded[1] + "mm", _uploaded[2], (_uploaded[3] + (large ? 30 : 20)));

				uploaded.restore();
			}

			function resetCanvas () {
				original.setTransform(1, 0, 0, 1, 0, 0);
				original.clearRect(0, 0, canvas.width, canvas.height);
				uploaded.setTransform(1, 0, 0, 1, 0, 0);
				uploaded.clearRect(0, 0, canvas.width, canvas.height);
			}

			if (toggle) {
				resetCanvas();
				generateOriginal();
				generateUploaded();
			} else {
				resetCanvas();
				generateUploaded();
				generateOriginal();
			}
		},
		toggle () {
			this.viewingPdf = !this.viewingPdf;
		}
	},
	mounted () {
		this.generateCanvas(this.viewingPdf);
	},
	watch: {
		viewingPdf (a, b) {
			this.generateCanvas(this.viewingPdf);
		}
	}
};
</script>

<style lang="scss">
.configurator-canvas {
	max-width: 100%;
}

.configurator-canvas__holder {
	position: relative;
}

.switch-sides {
	text-align: center;
    position: absolute;
    bottom: 50%;
    transform: translateY(50%);
    right: 0;
    left: 0;
    color: #666;
    font-size: 1rem;
	user-select: none;
	font-weight: 300;

	&--light {
		color: #fff;
	}

	&--large {
		font-size: 1.3rem;
	}

	span {
		display: block;
	}
}

.switch-sides__link {
	text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/element/specification-canvas.vue